module.exports = __webpack_public_path__ + "static/media/img-reynosa-2.7566021b.jpg";